<template>
  <div class="contain">
    <div class="search fl_bet">
      <div class="left fl_cen">
        <div>
          <el-input
            v-model="query.name"
            size="small"
            placeholder="产品线名称"
            style="width: 208px"
            clearable
            @keyup.enter.native="queryTableData(1)"
          />
          <el-button
            size="small"
            type="primary"
            style="margin-left: 10px"
            @click="queryTableData(1)"
            >查询</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
        <div>
          <el-button
            size="small"
            style="margin-left: 10px"
            @click="settleApplyPhone"
            >控销品咨询电话</el-button
          >
        </div>
      </div>
    </div>
    <Tabs
      @tab-click="handleClick"
      style="padding: 0 24px"
      :tabsList="tabsList"
      :activeName.sync="activeName"
    ></Tabs>
    <div class="my-table">
      <myTable
        :selection="false"
        :page="page"
        :showpage="true"
        :operation="false"
        v-loading="isLoading"
        :table-data="tableData"
        :table-option.sync="tableOption"
        @page-change="getList"
        :expand="false"
      >
        <template slot="operation" slot-scope="scope">
          <div style="margin: 0 0px">
            <el-link
              type="primary"
              :underline="false"
              @click="checkDetails(scope.row, 'edit')"
              style="margin-right: 10px"
              v-if="scope.row.applyStatus == 2"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              @click="checkDetails(scope.row, 'detail')"
              style="margin-right: 10px"
              v-if="scope.row.applyStatus == 3"
            >
              详情
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              @click="auditProductLine(scope.row, 'audit')"
              style="margin-right: 10px"
              v-if="scope.row.applyStatus == 1"
            >
              审核
            </el-link>
          </div>
        </template>
        <!-- applyStatus -->
        <template slot="applyStatus" slot-scope="scope">
          <div>
            {{ getStatus("productLine", scope.row.applyStatus) }}
          </div>
        </template>
        <!-- goodsName -->
        <template slot="goodsName" slot-scope="scope">
          <div class="product-item">
            <div>
              <el-image
                style="width: 100px; height: 100px; background: #fff"
                :src="scope.row.plProductGoodsBaseDTO.image || ''"
                :fit="'cover'"
                v-if="scope.row.plProductGoodsBaseDTO.image"
              />
            </div>
            <div class="product-rt">
              <div class="ellipsis item-l">
                {{ scope.row.plProductGoodsBaseDTO.name }}
              </div>
              <div class="ellipsis item-l">
                {{ scope.row.plProductGoodsBaseDTO.factory }}
              </div>
              <div class="ellipsis item-l">
                {{ scope.row.plProductGoodsBaseDTO.specification }}
              </div>
              <div class="ellipsis item-l">
                {{ scope.row.plProductGoodsBaseDTO.approvalNumber }}
              </div>
            </div>
          </div>
        </template>
      </myTable>
    </div>
    <MutilCtrPhoneSettingDialog ref="mutilCtrPhoneSettingDialogRef" @submit="submitMutilCtrPhoneSetting"/>

    </MutilCtrPhoneSettingDialog>
  </div>
</template>
<script>
// import { correspondingVal } from '@/util/validate'
import { mapState, mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import Tabs from "@/components/Tabs";
import MutilCtrPhoneSettingDialog from "./components/MutilCtrPhoneSettingDialog";
import {
  plProductBagsPlatformPage,
  plProductBagsPlatformAuditCount,
} from "@/api/saleRule/agent.js";
import { dkcSetContactTel,dkcGetContactTel } from "@/api/saleRule/agent.js";
import myTable from "@/components/myTable";

export default {
  name: "ProductLineAudit",
  components: {
    Tabs,
    myTable,
    MutilCtrPhoneSettingDialog
  },
  data() {
    return {
      activeName: "first", // tabs 传的值
      tabsList: [
        // tabs 传的值
        {
          name: "first",
          label: "全部",
          value: 0,
        },
        {
          name: "1",
          label: "待审核",
          value: 0,
        },
        {
          name: "2",
          label: "已通过",
          value: 0,
        },
        {
          name: "3",
          label: "已驳回",
          value: 0,
        },
      ],

      isLoading: false,
      query: {},
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "产品线名称", prop: "name", width: 200 },
        { label: "产品线负责人", prop: "principalName", width: 200 },
        { label: "合作团队", prop: "teamShopName", width: 200 },
        { label: "控销产品", prop: "goodsName", width: 400, slot: true },
        { label: "控销分类", prop: "saleCategoryName", width: 200 },
        { label: "审核状态", prop: "applyStatus", width: 200, slot: true },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          // fixed: "right",
        },
      ],
      tableList: [],
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    getStatus() {
      return (type, status) => this.checkStatus(type, status);
    },
  },
  methods: {
    checkStatus(type, status) {
      // return checkStatus(type, status);
      switch (status) {
        case 1:
          return "待审核";
        case 2:
          return "已通过";
        case 3:
          return "已驳回";
        default:
          return "";
      }
    },
    checkDetails(row, type) {
      this.$router.push({
        path: "/agentSalesControl/agentSalesControl-productLineAuditDetail",
        query: {
          id: row.id,
          type: type,
        },
      });
    },
    auditProductLine(row, type) {
      this.$router.push({
        path: "/agentSalesControl/agentSalesControl-productLineAuditDetail",
        query: {
          id: row.id,
          type: type,
        },
      });
    },
    // 设置 - 控销品咨询电话
    settleApplyPhone() {
      this.getMultiCtrPhoneSetting();
    },
    submitMutilCtrPhoneSetting(e){
      const {phoneNum } = e;
      dkcSetContactTel(phoneNum).then((res) => {
        if (res) {
          this.$message.success("设置成功");
        }
      })
    },
    getMultiCtrPhoneSetting() {
      dkcGetContactTel().then((res) => {
        this.$refs.mutilCtrPhoneSettingDialogRef.publicOpen(res || '');
      })
    },
    queryTableData(current) {
      if (current) {
        this.page.current = current;
      }
      let params = {
        ...this.query,
        current: this.page.current,
        size: this.page.size,
      };
      plProductBagsPlatformPage(params).then((res) => {
        this.tableData = res.records;
        this.page.total = res.total;
      });
      plProductBagsPlatformAuditCount({}).then((res) => {
        this.tabsList[1].value = res[0].count;
      });
    },
    getList(current) {
      this.queryTableData(current);
    },
    // 重置
    reset() {
      this.query = {};
      this.activeName = "first";
      this.getList(1);
    },
    handleClick(tab, event) {
      if (this.activeName == "first") {
        this.query.applyStatus = "";
      } else {
        this.query.applyStatus = this.activeName;
      }
      this.queryTableData(1);
    },
  },
  created() {},
  mounted() {
    this.getList(1);
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/index.scss";
@import "../../styles/main";
.contain {
  padding: 0px;
  background: #fff;
  height: calc(100% - 10px);
  .headerTabs {
    padding: 0px 24px;
    border-bottom: 1px solid #f5f5f5;
  }

  .search {
    margin-left: 24px !important;
    margin-right: 24px !important;
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 20px;
  }

  .bottom {
    margin: 0 24px;
  }
  .fl_cen {
    display: flex;
    justify-content: space-between;
  }
}
.my-table {
  padding: 0 24px;
  height: calc(100% - 180px);
}
.product-item {
  display: flex;
  justify-content: flex-start;
}
.product-rt {
  width: calc(100% - 100px);
  margin-left: 10px;
  div {
    text-align: left;
  }
  .item-l {
    width: 100%;
    line-height: 24px;
    margin: 0;
    display: block;
  }
}
</style>
